import FirmWizard from "./FirmWizard";
import LargeScreenNotice from "../common/LargeScreenNotice";

const Firms = () => {
  return (
    <div className="grid grid-cols-1">
      <LargeScreenNotice pageKey="visit-plan" />
      <div className="min-h-[670px] h-auto">
        <FirmWizard />
      </div>
    </div>
  );
};

export default Firms;
